import get from "lodash/get";

class PaymentOption {
  constructor(paymentOptionObj) {
    this.obj = paymentOptionObj;
  }
  getId() {
    return get(this.obj, "id", undefined);
  }

  getType() {
    return get(this.obj, "attributes.payment_option", undefined);
  }

  getName() {
    return get(this.obj, "attributes.name", undefined);
  }

  getBanners() {
    return get(this.obj, "attributes.promotional_banner", undefined);
  }

  isOnline() {
    const onlinePaymentList = ["stronghold", "merrco"];
    return onlinePaymentList.includes(this.getType());
  }

  supportsGuestCheckout() {
    const noGuestCheckoutList = ["stronghold", "spence"];
    return !noGuestCheckoutList.includes(this.getType());
  }

  supportsTipping() {
    return get(this.obj, "attributes.allows_tips", false);
  }
}

function makePaymentOption(attrs) {
  return new PaymentOption(attrs);
}

export default makePaymentOption;
